// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
import CollectionActionTypes from './collection-approve.types';

/** ***************** GET BRANCH OFFICER CENTERS LIST START *********************** */
export const fetchOfficerListCentersStart = (getData: any) => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_CENTERS_START,
	payload: getData,
});

export const getOfficerListCentersSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_CENTERS_SUCCESS,
	payload: successData,
});

export const getOfficerListCentersFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_CENTERS_FAILURE,
	payload: failureData,
});

export const fetchOfficerListCentersResponseResetStart = () => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_CENTERS_RESPONSE_RESET,
});

export const getOfficerListCentersResponseChanged = () => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_CENTERS_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH OFFICER CENTERS LIST END *********************** */

/** ***************** GET BRANCH OFFICER ARREAR CENTERS LIST START *********************** */
export const fetchOfficerListArrearCentersStart = (getData: any) => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_START,
	payload: getData,
});

export const getOfficerListArrearCentersSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_SUCCESS,
	payload: successData,
});

export const getOfficerListArrearCentersFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_FAILURE,
	payload: failureData,
});

export const fetchOfficerListArrearCentersResponseResetStart = () => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_RESPONSE_RESET,
});

export const getOfficerListArrearCentersResponseChanged = () => ({
	type: CollectionActionTypes.GET_OFFICER_LIST_ARREAR_CENTERS_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH OFFICER ARREAR CENTERS LIST END *********************** */

/** ***************** GET BRANCH COLLECTION USERS LIST START *********************** */
export const fetchBranchCollectionUsersListStart = (getData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_START,
	payload: getData,
});

export const getBranchCollectionUsersListSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_SUCCESS,
	payload: successData,
});

export const getBranchCollectionUsersListFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_FAILURE,
	payload: failureData,
});

export const fetchBranchCollectionUsersListResponseResetStart = () => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_RESPONSE_RESET,
});

export const getBranchCollectionUsersListResponseChanged = () => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_USERS_LIST_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH OFFICER ARREAR CENTERS LIST END *********************** */

/** ***************** GET CENTER LIST OFFICER COLLECTIONS START *********************** */
export const fetchCenterListOfficerCollectionsStart = (getData: any) => ({
	type: CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_START,
	payload: getData,
});

export const getCenterListOfficerCollectionsSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_SUCCESS,
	payload: successData,
});

export const getCenterListOfficerCollectionsFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_FAILURE,
	payload: failureData,
});

export const fetchCenterListOfficerCollectionsResponseResetStart = () => ({
	type: CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_RESPONSE_RESET,
});

export const getCenterListOfficerCollectionsResponseChanged = () => ({
	type: CollectionActionTypes.GET_CENTER_LIST_OFFICER_COLLECTIONS_RESPONSE_CHANGED,
});
/** ***************** GET CENTER LIST OFFICER COLLECTIONS END *********************** */

/** ***************** GET BRANCH TODAY COLLECTION START *********************** */
export const fetchBranchTodayCollectionDetailsStart = (getData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getBranchTodayCollectionDetailsSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getBranchTodayCollectionDetailsFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchBranchTodayCollectionDetailsReset = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_RESET,
});

export const getBranchTodayCollectionDetailsChanged = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_DETAILS_CHANGED,
});
/** ***************** GET BRANCH TODAY COLLECTION END *********************** */

/** ***************** GET BRANCH TODAY DEMAND MOVE TO ARREAR START *********************** */
export const fetchBranchTodayDemandMoveToArrearStart = (getData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_START,
	payload: getData,
});

export const getBranchTodayDemandMoveToArrearSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_SUCCESS,
	payload: successData,
});

export const getBranchTodayDemandMoveToArrearFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_FAILURE,
	payload: failureData,
});

export const fetchBranchTodayDemandMoveToArrearReset = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_RESET,
});

export const getBranchTodayDemandMoveToArrearChanged = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_DEMAND_MOVETOARREAR_LIST_CHANGED,
});
/** ***************** GET BRANCH TODAY DEMAND MOVE TO ARREAR  END *********************** */

/** ***************** GET BRANCH CLOSED LOAN LIST START *********************** */
export const fetchBranchClosedLoanListStart = (getData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_START,
	payload: getData,
});

export const getBranchClosedLoanListSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const getBranchClosedLoanListFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchBranchClosedLoanListReset = () => ({
	type: CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_RESET,
});

export const getBranchClosedLoanListChanged = () => ({
	type: CollectionActionTypes.GET_BRANCH_CLOSED_LOAN_LIST_CHANGED,
});
/** ***************** GET BRANCH CLOSED LOAN LIST END *********************** */

/** ***************** GET CENTER COLLECTION DENOMINATION START *********************** */
export const fetchCenterCollectionDenominationStart = (getData: any) => ({
	type: CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_START,
	payload: getData,
});

export const getCenterCollectionDenominationSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_SUCCESS,
	payload: successData,
});

export const getCenterCollectionDenominationFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchCenterCollectionDenominationReset = () => ({
	type: CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_RESET,
});

export const getCenterCollectionDenominationChanged = () => ({
	type: CollectionActionTypes.GET_CENTER_COLLECTION_DENOMINATION_DETAILS_CHANGED,
});
/** ***************** GET CENTER COLLECTION DENOMINATION END *********************** */

/** ***************** GET CENTER COLLECTION DENOMINATION START *********************** */
export const fetchAttendanceOfficerCollectionStart = (getData: any) => ({
	type: CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_START,
	payload: getData,
});

export const getAttendanceOfficerCollectionSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_SUCCESS,
	payload: successData,
});

export const getAttendanceOfficerCollectionFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_FAILURE,
	payload: failureData,
});

export const fetchAttendanceOfficerCollectionReset = () => ({
	type: CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_RESET,
});

export const getAttendanceOfficerCollectionChanged = () => ({
	type: CollectionActionTypes.GET_ATTENDANCE_OFFICER_COLLECTION_CHANGED,
});
/** ***************** GET CENTER COLLECTION DENOMINATION END *********************** */

/** ***************** GET BRANCH COLLECTION FUNDER ALLOCATE EOD START *********************** */
export const fetchBranchCollectionFunderAllocateEODStart = (getData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_START,
	payload: getData,
});

export const getBranchCollectionFunderAllocateEODSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_SUCCESS,
	payload: successData,
});

export const getBranchCollectionFunderAllocateEODFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_FAILURE,
	payload: failureData,
});

export const fetchBranchCollectionFunderAllocateEODReset = () => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_RESET,
});

export const getBranchCollectionFunderAllocateEODChanged = () => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED,
});

export const getBranchCollectionFunderAllocateEODChangedData = () => ({
	type: CollectionActionTypes.GET_BRANCH_COLLECTION_FUNDER_ALLOCATE_EOD_CHANGED_DATA,
});
/** ***************** GET BRANCH COLLECTION FUNDER ALLOCATE EOD END *********************** */

/** ***************** GET BRANCH TODAY COLLECTIONS YET TO APPROVE START *********************** */
export const fetchBranchTodayCollectionsYetToApproveStart = (getData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_START,
	payload: getData,
});

export const getBranchTodayCollectionsYetToApproveSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_SUCCESS,
	payload: successData,
});

export const getBranchTodayCollectionsYetToApproveFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_FAILURE,
	payload: failureData,
});

export const fetchBranchTodayCollectionsYetToApproveReset = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_RESET,
});

export const getBranchTodayCollectionsYetToApproveChanged = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED,
});

export const getBranchTodayCollectionsYetToApproveChangedData = () => ({
	type: CollectionActionTypes.GET_BRANCH_TODAY_COLLECTION_YET_TO_APPROVE_CHANGED_DATA,
});
/** ***************** GET BRANCH TODAY COLLECTIONS YET TO APPROVE END *********************** */

/** ***************** UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE START *********************** */
export const updateLoanPaidPerMemberCollectionApproveStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_START,
	payload: getData,
});

export const updateLoanPaidPerMemberCollectionApproveSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_SUCCESS,
	payload: successData,
});

export const updateLoanPaidPerMemberCollectionApproveFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_FAILURE,
	payload: failureData,
});

export const updateLoanPaidPerMemberCollectionApproveResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_RESPONSE_RESET,
});

export const updateLoanPaidPerMemberCollectionApproveResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_PER_MEMBER_COLLECTION_APPROVE_CHANGED,
});
/** ***************** UPDATE LOAN PAID PER MEMBER COLLECTION APPROVE END *********************** */

/** ***************** UPDATE LOAN PAID OVERALL COLLECTION APPROVE START *********************** */
export const updateLoanPaidOverallCollectionApproveStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_START,
	payload: getData,
});

export const updateLoanPaidOverallCollectionApproveSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_SUCCESS,
	payload: successData,
});

export const updateLoanPaidOverallCollectionApproveFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_FAILURE,
	payload: failureData,
});

export const updateLoanPaidOverallCollectionApproveResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_RESPONSE_RESET,
});

export const updateLoanPaidOverallCollectionApproveResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_COLLECTION_APPROVE_CHANGED,
});
/** ***************** UPDATE LOAN PAID OVERALL COLLECTION APPROVE END *********************** */

/** ***************** SECURITY CHECK PASSWORD VERIFY START *********************** */
export const securityCheckPasswordVerifyStart = (getData: any) => ({
	type: CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_START,
	payload: getData,
});

export const securityCheckPasswordVerifySuccess = (successData: any) => ({
	type: CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_SUCCESS,
	payload: successData,
});

export const securityCheckPasswordVerifyFailure = (failureData: any) => ({
	type: CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_FAILURE,
	payload: failureData,
});

export const securityCheckPasswordVerifyResponseReset = () => ({
	type: CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_RESPONSE_RESET,
});

export const securityCheckPasswordVerifyResponseChanged = () => ({
	type: CollectionActionTypes.SECURITY_CHECK_PASSWORD_VERIFY_CHANGED,
});
/** ***************** SECURITY CHECK PASSWORD VERIFY END *********************** */

/** ***************** REVERT ALLOCATE FOR EOD START *********************** */
export const revertAllocateForEodStart = (getData: any) => ({
	type: CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_START,
	payload: getData,
});

export const revertAllocateForEodSuccess = (successData: any) => ({
	type: CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_SUCCESS,
	payload: successData,
});

export const revertAllocateForEodFailure = (failureData: any) => ({
	type: CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_FAILURE,
	payload: failureData,
});

export const revertAllocateForEodResponseReset = () => ({
	type: CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_RESPONSE_RESET,
});

export const revertAllocateForEodResponseChanged = () => ({
	type: CollectionActionTypes.REVERT_ALLOCATE_FOR_EOD_CHANGED,
});
/** ***************** REVERT ALLOCATE FOR EOD END *********************** */

/** ***************** UPDATE LOAN PAID COMMON COLLECTION START *********************** */
export const commonCollectionUpdateStart = (getData: any) => ({
	type: CollectionActionTypes.COMMON_COLLECTION_UPDATE_START,
	payload: getData,
});

export const commonCollectionUpdateSuccess = (successData: any) => ({
	type: CollectionActionTypes.COMMON_COLLECTION_UPDATE_SUCCESS,
	payload: successData,
});

export const commonCollectionUpdateFailure = (failureData: any) => ({
	type: CollectionActionTypes.COMMON_COLLECTION_UPDATE_FAILURE,
	payload: failureData,
});

export const commonCollectionUpdateResponseReset = () => ({
	type: CollectionActionTypes.COMMON_COLLECTION_UPDATE_RESPONSE_RESET,
});

export const commonCollectionUpdateResponseChanged = () => ({
	type: CollectionActionTypes.COMMON_COLLECTION_UPDATE_CHANGED,
});
/** ***************** UPDATE LOAN PAID COMMON COLLECTION END *********************** */

/** ***************** CHECK EOD EXIST START *********************** */
export const checkBranchEODExistStart = (getData: any) => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_START,
	payload: getData,
});

export const checkBranchEODExistSuccess = (successData: any) => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_SUCCESS,
	payload: successData,
});

export const checkBranchEODExistFailure = (failureData: any) => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FAILURE,
	payload: failureData,
});

export const checkBranchEODExistResponseReset = () => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_RESPONSE_RESET,
});

export const checkBranchEODExistResponseChanged = () => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_CHANGED,
});
/** ***************** CHECK EOD EXIST END *********************** */

/** ***************** CHECK EOD EXIST FOR DATE START *********************** */
export const checkBranchEODExistForDateStart = (getData: any) => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_START,
	payload: getData,
});

export const checkBranchEODExistForDateSuccess = (successData: any) => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_SUCCESS,
	payload: successData,
});

export const checkBranchEODExistForDateFailure = (failureData: any) => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_FAILURE,
	payload: failureData,
});

export const checkBranchEODExistForDateResponseReset = () => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_RESPONSE_RESET,
});

export const checkBranchEODExistForDateResponseChanged = () => ({
	type: CollectionActionTypes.CHECK_BRANCH_EOD_EXIST_FOR_DATE_CHANGED,
});
/** ***************** CHECK EOD EXIST FOR DATE END *********************** */

/** ***************** UPDATE LOAN PAID OVERALL MOVE TO ARREAR START *********************** */
export const updateLoanPaidOverAllMoveToArrearStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_START,
	payload: getData,
});

export const updateLoanPaidOverAllMoveToArrearSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_SUCCESS,
	payload: successData,
});

export const updateLoanPaidOverAllMoveToArrearFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_FAILURE,
	payload: failureData,
});

export const updateLoanPaidOverAllMoveToArrearResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_RESPONSE_RESET,
});

export const updateLoanPaidOverAllMoveToArrearResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_LOANPAID_OVERALL_MOVE_TO_ARREAR_CHANGED,
});
/** ***************** UPDATE LOAN PAID OVERALL MOVE TO ARREAR END *********************** */

/** ***************** UPDATE LOAN PAID OVERALL ACCRUED INTEREST ALLOCATE FOR EOD START *********************** */
export const updateOverallAccruedInterestAllocateForEODStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_START,
	payload: getData,
});

export const updateOverallAccruedInterestAllocateForEODSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_SUCCESS,
	payload: successData,
});

export const updateOverallAccruedInterestAllocateForEODFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_FAILURE,
	payload: failureData,
});

export const updateOverallAccruedInterestAllocateForEODResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_RESPONSE_RESET,
});

export const updateOverallAccruedInterestAllocateForEODResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ACCRUED_INTEREST_ALLOCATE_FOR_EOD_CHANGED,
});
/** ***************** UPDATE LOAN PAID OVERALL ACCRUED INTEREST ALLOCATE FOR EOD END *********************** */

/** ***************** UPDATE LOAN PAID OVERALL ALLOCATE FOR EOD START *********************** */
export const updateOverallAllocateForEODStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_START,
	payload: getData,
});

export const updateOverallAllocateForEODSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_SUCCESS,
	payload: successData,
});

export const updateOverallAllocateForEODFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_FAILURE,
	payload: failureData,
});

export const updateOverallAllocateForEODResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_RESPONSE_RESET,
});

export const updateOverallAllocateForEODResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_OVERALL_ALLOCATE_FOR_EOD_CHANGED,
});
/** ***************** UPDATE LOAN PAID OVERALL ALLOCATE FOR EOD END *********************** */

/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST START *********************** */
export const fetchGoldLoanCollectionApproveListStart = (getData: any) => ({
	type: CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_START,
	payload: getData,
});

export const fetchGoldLoanCollectionApproveListSuccess = (successData: any) => ({
	type: CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_SUCCESS,
	payload: successData,
});

export const fetchGoldLoanCollectionApproveListFailure = (failureData: any) => ({
	type: CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_FAILURE,
	payload: failureData,
});

export const fetchGoldLoanCollectionApproveListResponseReset = () => ({
	type: CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_RESPONSE_RESET,
});

export const fetchGoldLoanCollectionApproveListResponseChanged = () => ({
	type: CollectionActionTypes.FETCH_GOLD_LOAN_COLLECTION_APPROVE_LIST_RESPONSE_CHANGED,
});
/** ***************** FETCH GOLD LOAN COLLECTION APPROVE LIST END *********************** */

/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS START *********************** */
export const fetchSavingsCollectionApproveDetailsStart = (getData: any) => ({
	type: CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_START,
	payload: getData,
});

export const fetchSavingsCollectionApproveDetailsSuccess = (successData: any) => ({
	type: CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchSavingsCollectionApproveDetailsFailure = (failureData: any) => ({
	type: CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchSavingsCollectionApproveDetailsResponseReset = () => ({
	type: CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_RESPONSE_RESET,
});

export const fetchSavingsCollectionApproveDetailsResponseChanged = () => ({
	type: CollectionActionTypes.FETCH_SAVINGS_COLLECTION_APPROVE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH SAVINGS COLLECTION APPROVE DETAILS END *********************** */

/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD START *********************** */
export const updateSavingsAllocateForEODStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_START,
	payload: getData,
});

export const updateSavingsAllocateForEODSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_SUCCESS,
	payload: successData,
});

export const updateSavingsAllocateForEODFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_FAILURE,
	payload: failureData,
});

export const updateSavingsAllocateForEODResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_RESPONSE_RESET,
});

export const updateSavingsAllocateForEODResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_ALLOCATE_FOR_EOD_CHANGED,
});
/** ***************** UPDATE SAVINGS ALLOCATE FOR EOD END *********************** */

/** ***************** FETCH SAVINGS DENOMINATION DETAILS START *********************** */
export const fetchSavingsDenominationDetailsStart = (getData: any) => ({
	type: CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_START,
	payload: getData,
});

export const fetchSavingsDenominationDetailsSuccess = (successData: any) => ({
	type: CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchSavingsDenominationDetailsFailure = (failureData: any) => ({
	type: CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchSavingsDenominationDetailsResponseReset = () => ({
	type: CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_RESPONSE_RESET,
});

export const fetchSavingsDenominationDetailsResponseChanged = () => ({
	type: CollectionActionTypes.GET_SAVINGS_DENOMINATION_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH SAVINGS DENOMINATION DETAILS END *********************** */

/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE START *********************** */
export const updateGoldLoanCollectionApproveStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_START,
	payload: getData,
});

export const updateGoldLoanCollectionApproveSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_SUCCESS,
	payload: successData,
});

export const updateGoldLoanCollectionApproveFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_FAILURE,
	payload: failureData,
});

export const updateGoldLoanCollectionApproveResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_RESPONSE_RESET,
});

export const updateGoldLoanCollectionApproveResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_GOLD_LOAN_COLLECTION_APPROVE_RESPONSE_CHANGED,
});
/** ***************** UPDATE GOLD LOAN COLLECTION APPROVE END *********************** */

/** ***************** UPDATE SAVINGS COLLECTION APPROVE START *********************** */
export const updateSavingsCollectionApproveStart = (getData: any) => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_START,
	payload: getData,
});

export const updateSavingsCollectionApproveSuccess = (successData: any) => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_SUCCESS,
	payload: successData,
});

export const updateSavingsCollectionApproveFailure = (failureData: any) => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_FAILURE,
	payload: failureData,
});

export const updateSavingsCollectionApproveResponseReset = () => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_RESPONSE_RESET,
});

export const updateSavingsCollectionApproveResponseChanged = () => ({
	type: CollectionActionTypes.UPDATE_SAVINGS_COLLECTION_APPROVE_RESPONSE_CHANGED,
});
/** ***************** UPDATE SAVINGS COLLECTION APPROVE END *********************** */

/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS START *********************** */
export const submitApproveStaffTravelDetailsStart = (getData: any) => ({
	type: CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_START,
	payload: getData,
});

export const submitApproveStaffTravelDetailsSuccess = (successData: any) => ({
	type: CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_SUCCESS,
	payload: successData,
});

export const submitApproveStaffTravelDetailsFailure = (failureData: any) => ({
	type: CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_FAILURE,
	payload: failureData,
});

export const submitApproveStaffTravelDetailsResponseReset = () => ({
	type: CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_RESPONSE_RESET,
});

export const submitApproveStaffTravelDetailsResponseChanged = () => ({
	type: CollectionActionTypes.SUBMIT_APPROVE_STAFF_TRAVEL_DETAILS_RESPONSE_CHANGED,
});
/** ***************** SUBMIT APPROVE STAFF TRAVEL DETAILS END *********************** */
